import React, { useEffect, useState } from 'react';
import { WHATSAPP_LINK, LOGO_RECT } from '../lib/constants';
import { MessageCircle, Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    label: 'Inicio',
    href: '#inicio'
  }, {
    label: 'Servicios',
    href: '#servicios'
  }, {
    label: 'Contacto',
    href: '#footer'
  }, {
    label: 'Formulario',
    href: '#formulario'
  }];
  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <>
      <header className={`sticky top-0 left-0 right-0 z-50 w-full bg-mobal-black transition-all duration-300 ${isScrolled ? 'shadow-lg shadow-black/30' : ''}`} data-id="element-204">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-5" data-id="element-205">
          {/* Top row: WhatsApp | Logo | Menu */}
          <div className="flex justify-between items-center" data-id="element-206">
            {/* Left: WhatsApp Icon */}
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center bg-mobal-green text-mobal-black p-2.5 rounded-md hover:bg-[#b5ff33] transition-colors min-h-[44px] min-w-[44px]" aria-label="Contactar por WhatsApp" data-id="element-207">
              <MessageCircle className="w-6 h-6" data-id="element-208" />
            </a>

            {/* Center: Logo - clearly visible, medium-large */}
            <a href="#inicio" onClick={e => handleNavClick(e, '#inicio')} className="flex items-center justify-center" data-id="element-209">
              <img src="https://cdn.magicpatterns.com/uploads/sTBYKR7U6bMKUaUtjJjf8a/WhatsApp_Image_2026-04-23_at_00.43.05.jpg" alt="MOBAL FUMIGACIONES" className="h-12 sm:h-14 md:h-16 w-auto object-contain rounded-full mix-blend-screen" data-id="element-210" />
            </a>

            {/* Right: Desktop Nav or Hamburger */}
            <div className="flex items-center" data-id="element-211">
              {/* Desktop nav links */}
              <nav className="hidden lg:flex items-center gap-6 mr-2" data-id="element-212">
                {navLinks.map(link => <a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} className="text-mobal-white hover:text-mobal-green transition-colors font-body font-medium text-sm uppercase tracking-wide" data-id="element-213">
                    {link.label}
                  </a>)}
              </nav>

              {/* Hamburger for mobile/tablet */}
              <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden flex items-center justify-center text-mobal-white p-2 min-h-[44px] min-w-[44px]" aria-label="Abrir menú" data-id="element-214">
                {isMobileMenuOpen ? <X className="w-7 h-7" data-id="element-215" /> : <Menu className="w-7 h-7" data-id="element-216" />}
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <AnimatePresence data-id="element-217">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -20
      }} transition={{
        type: 'tween',
        duration: 0.25
      }} className="fixed inset-0 z-40 lg:hidden" data-id="element-218">
            <div className="absolute inset-0 bg-black/50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-219" />
            <div className="absolute top-0 left-0 right-0 bg-mobal-black border-b border-gray-800 pt-20 pb-8 shadow-2xl" data-id="element-220">
              <nav className="flex flex-col items-center gap-6 px-8" data-id="element-221">
                {navLinks.map((link, index) => <motion.a key={link.href} href={link.href} onClick={e => handleNavClick(e, link.href)} initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.08
            }} className="text-mobal-white hover:text-mobal-green transition-colors font-heading font-bold text-xl uppercase tracking-wide" data-id="element-222">
                    {link.label}
                  </motion.a>)}
              </nav>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}